import { Bounds } from 'models/map'

export enum Events {
  RefreshLayer = 'refreshLayer',
  FlyToBounds = 'flyToBounds',
}

export type RefreshLayer = { sourceLayer: string }
export type FlyToBounds = { bounds: Bounds }
